export default "__VITE_ASSET__c12e3100__"